import Base from './base'

export default class SavedFilters extends Base {
  list(params: object) {
    return this.apiClient.get('/saved-filters', params)
  }

  create(data: object) {
    return this.apiClient.post('/saved-filters', data)
  }

  update(id: string, data: object) {
    return this.apiClient.put(`/saved-filters/${id}`, data)
  }

  delete(id: string) {
    return this.apiClient.delete(`/saved-filters/${id}`)
  }
}
